import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Alert, Button } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
//import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { API_SERVER_FILES, API_URI_CVTheque, getCVThequeENV } from '../../config';
import { countries } from '../../data/Interfaces';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useFormValidation from '../../hooks/useFormValidation';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import StatutDocument from '../../Pages/Client/DocAdministratifs/StatutDocument';
import { formatDateJJMMYYYY} from '../../Utils/dateFormatter';
import CardUpload from '../../Utils/fileUpload/CardUpload';
import DocumentUpload from '../../Utils/fileUpload/DocumentUpload';
import { CompareTwoString, getTimeFromIsoFormatDate,SpliUrl } from '../../Utils/utils';
import { DatePickerComponent, SelectComponent, TextFieldComponent } from '../shared/ReusableSmallComponents';
import { buttonStyles, buttonStylesBlue, uploadDocStyles } from './JsObjectStyles';

export const europeOprion = [{ value: 'CIN', label: 'CIN' }, { value: 'Passeport', label: 'Passeport' }];
export const nonEuropeOption = [{ value: 'Passeport', label: 'Passeport' }];

export const euro = ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Czech Republic', 'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Poland', 'Portugal', 'Republic of Cyprus', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden'];

function CardIdOCR() {
    const { setShowErrors, setErrors, setBackdropOpen } = useUtilities();
    const { inputSize } = useWindowSize();
    const axiosPrivate = useAxiosPrivate();
    const { i18n } = useTranslation();
    const [possibleDocs, setPossibleDocs] = useState([]);
    const [selectedPays, setSelectedPays] = useState();
    const [numeroCIN, setNumeroCIN] = React.useState('');
    const [dateExpirationCIN, setDateExpirationCIN] = React.useState(null);
    const [numeroPass, setNumeroPass] = React.useState('');
    const [datePass, setDatePass] = React.useState(null);
    const [recto, setRecto] = useState('');
    const {device}=useWindowSize();
    const [verso, setVerso] = useState('');
    const [passeport, setPasseport] = useState('');
    const [typeDocument, setTypeDocument] = useState('');
    const [CheckUpdateValue, setCheckUpdateValue] = useState(false);
    const [expiredMessage, setExpiredMessage] = useState('');
    const [documentAdministratifs, setDocumentAdministratifs] = useState([]);
    const [autocompleteKey, setAutocompleteKey] = useState(0);
    const [isValid] = (passeport && passeport!='') ? useFormValidation([
        { name: 'selectedPays', value: selectedPays },
        { name: 'typeDocument', value: typeDocument },
        { name: 'numeroPass', value: numeroPass },
        { name: 'datePass', value: datePass },
    ]) : useFormValidation([
        { name: 'selectedPays', value: selectedPays },
        { name: 'typeDocument', value: typeDocument },
        { name: 'numeroCIN', value: numeroCIN },
        { name: 'dateExpirationCIN', value: dateExpirationCIN },
    ]);
    useEffect(() => {
        if (euro.includes(selectedPays)) {
            setPossibleDocs(europeOprion);
        }
        else {
            setPossibleDocs(nonEuropeOption);
        }
    }, [selectedPays]);

    useEffect(() => {
        if (recto !== '' && verso !== '') {
            uploadRectoToCvtheque();
        }
    }, [recto, verso]);

    useEffect(() => {
        if (passeport !== '') {
            uploadDocToCvtheque();
        }
    }, [passeport]);

    useEffect(() => {
        getDocumentAdministratifs();
    }, []);

    const uploadDocToCvtheque = async () => {
        console.log('URL \n\n');
        const formData = new FormData();
        setBackdropOpen(true);
        try {
            formData.append('file', passeport);
            formData.append('q', typeDocument);
            let response1, responseData1;
            if(getCVThequeENV() == 'remote'){
                response1 = await axiosPrivate.post(
                    '/proxy/uploadDocs',
                    formData,
                );
                responseData1 = response1.data;
            }
            else {
                response1 = await fetch(API_URI_CVTheque + 'uploadDocs', {
                    method: 'Post',
                    // headers: {
                    //     'Content-Type': 'multipart/form-data',
                    //     'accept': 'application/json'
                    // },
                    body: formData,
                });
                responseData1 = await response1.json();
            }

            console.log('submitresumeBackend', responseData1);
            setNumeroPass(responseData1?.Num);
            setDatePass(responseData1?.dateExpiration);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error.response?.status);
            setBackdropOpen(false);
        }
    };

    const uploadRectoToCvtheque = async () => {
        console.log('URL \n\n');
        const formData = new FormData();
        setBackdropOpen(true);
        console.log(typeDocument,);
        try {

            formData.append('file', recto);
            formData.append('q', typeDocument);
            let response1, responseData1;
            if(getCVThequeENV() == 'remote'){
                response1 = await axiosPrivate.post(
                    '/proxy/uploadDocs',
                    formData,
                );
                responseData1 = response1.data;
            }
            else {
                response1 = await fetch(API_URI_CVTheque + 'uploadDocs', {
                    method: 'Post',
                    // headers: {
                    //     'Content-Type': 'multipart/form-data',
                    //     'accept': 'application/json'
                    // },
                    body: formData,
                });
                responseData1 = await response1.json();
            }

            console.log('submitresumeBackend', responseData1);
            // setResult(responseData1);
            setNumeroCIN(responseData1?.Num);
            setDateExpirationCIN(responseData1?.dateExpiration);
            setBackdropOpen(false);
        } catch (error) {
            console.log(error.response?.status);
            setBackdropOpen(false);
        }
    };
    const checkExpiredCard =(dateExpiration) => {
        const currentDate = new Date();
        if(dateExpiration<currentDate)
            setExpiredMessage('Votre pièce d\'identité est expirée depuis le '+formatDateJJMMYYYY(dateExpiration));
        else
            setExpiredMessage('');
    };
    useEffect(() => {
        if(dateExpirationCIN)
            checkExpiredCard(dateExpirationCIN);
        if(datePass)
            checkExpiredCard(datePass);
    }, [dateExpirationCIN,datePass]);

    const getDocumentAdministratifs = async () => {
        var temp = [];
        try {
            console.log('HELLO FROM the get doc adminitratifs a valider Client useEffect');
            const response = await axiosPrivate.get('docAdministratif/getMyDocsAdministratifs');
            console.log('response', response.data);
            response.data.forEach(element => {
                if (element?.titre == 'cinRecto' || element?.titre == 'passeport')
                    temp.push(element);
            });
            setDocumentAdministratifs(temp.reverse());
        } catch (error) {
            console.log(error);
        }
    };

    const resetValues = () => {
        setCheckUpdateValue(true);
        setRecto('');
        setVerso('');
        setPasseport('');
        setTypeDocument('');
        setNumeroCIN('');
        setDateExpirationCIN(null);
        setSelectedPays();
        setAutocompleteKey((prevKey) => prevKey + 1);
    };

    const uploadToBackend = async (URL) => {
        console.log('URL \n\n', URL);
        const formData = new FormData();
        setBackdropOpen(true);
        try {
            if (numeroCIN)
                formData.append('noDoc', numeroCIN);
            if (dateExpirationCIN)
                formData.append('dateValidite', dateExpirationCIN);
            if (selectedPays)
                formData.append('pays', selectedPays);
            let correctEndPoint;
            if (recto !== '' && verso !== '') {
                formData.append('cinRecto', recto);
                formData.append('cinVerso', verso);
                correctEndPoint = '/docAdministratif/uploadDocumentsRectoVerso';
            } else if (passeport !== '') {
                if (numeroPass)
                    formData.append('noDoc', numeroPass);
                if (datePass)
                    formData.append('dateValidite', datePass);
                formData.append('passeport', passeport);
                correctEndPoint = '/docAdministratif/uploadDocumentOnly';
            }
            const response1 = await axiosPrivate.post(correctEndPoint, formData);
            console.log('submitresumeBackend', response1);
            getDocumentAdministratifs();
            resetValues();
        } catch (error) {
            console.log(error.response?.status, error.response.data?.error);
        }
        setBackdropOpen(false);
    };

    const supprimerPieceIdentite = async (docId) => {
        try {
            const response1 = await axiosPrivate.delete(
                'docAdministratif/deleteDocAdministratif/' + docId
            );
            console.log('delete msg', response1);
            getDocumentAdministratifs();
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    return (
        <form style={{ display: 'flex', width:device=='desktop'?'80%':'100%', gap: '16px', flexDirection: 'column', maxWidth: '929px', minWidth: device=='desktop'?'514px':'200px' }}>
            <h4 className='titlesociete'>{i18n.t('Pièce d\'identité')}</h4>
            {expiredMessage!='' && (
                <div>
                    <Alert severity="error">{expiredMessage}</Alert>
                </div>
            )}
            <div style={{ display: 'flex', alignSelf: 'stretch', gap: '20px', flexDirection: device=='desktop'?'row':'column' }}>
                <div style={{ display: 'flex', width: device=='desktop'?'50%':'100%' }}>
                    <Autocomplete
                        id="#"
                        key={autocompleteKey}
                        sx={{ width: '100%' }}
                        size={inputSize}
                        value={selectedPays}
                        onChange={(event, newValue) => {
                            if (!CompareTwoString(newValue?.label, selectedPays)) {
                                setCheckUpdateValue(false);
                            }
                            setSelectedPays(newValue?.label);
                        }}
                        options={countries}
                        autoHighlight
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                                {...props}
                            >
                                <img
                                    loading="lazy"
                                    width="20"
                                    src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                    srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                    alt=""
                                />
                                {option.label}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextFieldComponent
                                {...params}
                                style={{ background: 'white', borderRadius: '8px' }}
                                label={i18n.t('Choisir votre pays')}
                                inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'new-password',
                                }}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                            />
                        )}
                    />
                </div>
                <div style={{ display: 'flex', width:device=='desktop'?'50%':'100%' }}>
                    <SelectComponent
                        label={i18n.t('Type du document')}
                        val={typeDocument}
                        setVal={(e) => setTypeDocument(e.target.value)}
                        listVal={possibleDocs}
                    />
                </div>
            </div>
            <div style={{ display: 'flex', alignSelf: 'stretch', gap: '20px', flexDirection: 'column' }}>
                {typeDocument == 'CIN' &&
                    (<>
                        <p style={uploadDocStyles?.telechrgestyle}>{i18n.t('Télécharger votre pièce d\'identité scannée recto-verso')}</p>
                        <CardUpload
                            required
                            setFilerecto={setRecto}
                            setFileverso={setVerso}
                        />
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: device=='desktop'?'row':'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '16px',
                                alignSelf: 'stretch',}}
                        >
                            <TextFieldComponent
                                id="#"
                                size={inputSize}
                                value={numeroCIN}
                                name='numeroCIN'
                                label="Numéro de CIN"
                                onChange={(e) => {
                                    setNumeroCIN(e.target.value);
                                }}
                                style={{  borderRadius: '8px', width: device=='desktop' ?'50%':'100%'}}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                disabled={(recto && verso) ? false : true}
                            />
                            <DatePickerComponent
                                label="Date d'expiration"
                                date={dateExpirationCIN}
                                name='dateExpirationCIN'
                                setDate={(newValue) => {
                                    setDateExpirationCIN(newValue);
                                }}
                                disabled={(recto && verso) ? false : true}
                                width={device=='desktop' ?'50%':'100%'}
                            />
                        </div>
                    </>)
                }
                {typeDocument === 'Passeport' && (
                    <>
                        <p style={uploadDocStyles?.telechrgestyle}>{i18n.t('Télécharger l\'image de votre passeport')}</p>
                        <DocumentUpload
                            required
                            setFile={setPasseport}
                            setCheckUpdateValue={setCheckUpdateValue}
                            document={passeport}
                            accept='.png, .jpg, .jpeg'
                        />

                        <div
                            style={{
                                display: 'flex',
                                flexDirection: device=='desktop'?'row':'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '16px',
                                alignSelf: 'stretch',}}
                        >
                            <TextFieldComponent
                                id="#"
                                size={inputSize}
                                value={numeroPass}
                                label={i18n.t('Numéro du passeport')}
                                name='numeroPass'
                                onChange={(e) => {
                                    setNumeroPass(e.target.value);
                                }}
                                style={{ width:device=='desktop'?'50%':'100%', borderRadius: '8px' }}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px' },
                                }}
                                disabled={passeport ? false : true}
                                focused
                            />
                            <DatePickerComponent
                                label={i18n.t('Date Expiration')}
                                date={datePass}
                                name='datePass'
                                setDate={(newValue) => {
                                    setDatePass(newValue);
                                }}
                                disabled={passeport ? false : true}
                                focused
                                width={device=='desktop' ?'50%':'100%'}
                            />
                        </div>
                    </>)
                }
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignSelf: 'stretch' }}>
                    <Button
                        variant="contained"
                        type="submit"
                        style={{...buttonStylesBlue(CheckUpdateValue),...{width:device=='desktop'?'auto' :'100%'}}}
                        disabled={CheckUpdateValue}
                        onClick={(e) => {
                            e.preventDefault();
                            if (isValid) {
                                uploadToBackend();
                                setShowErrors(false);
                                setErrors({});
                            }
                            else setShowErrors(true);
                        }}
                        // onClick={uploadToBackend}
                    //startIcon={<SaveOutlinedIcon />}
                    >
                        {i18n.t('Valider')}
                    </Button>
                </div>
            </div>
            {documentAdministratifs.map((document) => (
                <>
                    <div
                        className='frame4DocCommerciaux'
                        key={document?._id + 1}
                    >
                        <div className='frame5DocCommerciaux'>
                            <div className='frame6DocCommerciaux'>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                                    <div className='frame7DocCommerciaux'>
                                        <div className='frame8DocCommerciaux'>
                                            <svg
                                                width="25"
                                                height="22"
                                                viewBox="0 0 25 22"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M8.125 4.625C6.85938 4.625 5.875 5.65625 5.875 6.875C5.875 8.14062 6.85938 9.125 8.125 9.125C9.34375 9.125 10.375 8.14062 10.375 6.875C10.375 5.65625 9.34375 4.625 8.125 4.625ZM21.9531 0.5H3.95312C2.3125 0.5 0.953125 1.85938 0.953125 3.5V18.5C0.953125 20.1875 2.3125 21.5 3.95312 21.5H21.9531C23.5938 21.5 24.9531 20.1875 24.9531 18.5V3.5C24.9531 1.85938 23.6406 0.5 21.9531 0.5ZM22.7031 18.2188L16.2812 9.5C16.1406 9.26562 15.9062 9.125 15.625 9.125C15.2969 9.125 15.0625 9.26562 14.875 9.5L9.90625 16.25L8.17188 14.0938C7.98438 13.9062 7.75 13.7656 7.46875 13.7656C7.1875 13.7656 6.95312 13.9062 6.76562 14.0938L3.25 18.5L3.20312 3.5C3.20312 3.125 3.57812 2.75 3.95312 2.75H21.9531C22.375 2.75 22.7031 3.125 22.7031 3.5V18.2188Z"
                                                    fill="#272D3C"
                                                />
                                            </svg>
                                        </div>
                                        <a
                                            href={API_SERVER_FILES + encodeURIComponent(document?.url)}
                                            className='frame9DocCommerciaux'
                                            target='_blank'
                                            rel="noreferrer"
                                        > {SpliUrl(document?.url)} </a>
                                    </div>
                                    {document?.titre == 'cinRecto' &&
                                        <div className='frame7DocCommerciaux'>
                                            <div className='frame8DocCommerciaux'>
                                                <svg
                                                    width="25"
                                                    height="22"
                                                    viewBox="0 0 25 22"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M8.125 4.625C6.85938 4.625 5.875 5.65625 5.875 6.875C5.875 8.14062 6.85938 9.125 8.125 9.125C9.34375 9.125 10.375 8.14062 10.375 6.875C10.375 5.65625 9.34375 4.625 8.125 4.625ZM21.9531 0.5H3.95312C2.3125 0.5 0.953125 1.85938 0.953125 3.5V18.5C0.953125 20.1875 2.3125 21.5 3.95312 21.5H21.9531C23.5938 21.5 24.9531 20.1875 24.9531 18.5V3.5C24.9531 1.85938 23.6406 0.5 21.9531 0.5ZM22.7031 18.2188L16.2812 9.5C16.1406 9.26562 15.9062 9.125 15.625 9.125C15.2969 9.125 15.0625 9.26562 14.875 9.5L9.90625 16.25L8.17188 14.0938C7.98438 13.9062 7.75 13.7656 7.46875 13.7656C7.1875 13.7656 6.95312 13.9062 6.76562 14.0938L3.25 18.5L3.20312 3.5C3.20312 3.125 3.57812 2.75 3.95312 2.75H21.9531C22.375 2.75 22.7031 3.125 22.7031 3.5V18.2188Z"
                                                        fill="#272D3C"
                                                    />
                                                </svg>
                                            </div>
                                            <a
                                                href={API_SERVER_FILES + encodeURIComponent(document?.verso)}
                                                className='frame9DocCommerciaux'
                                                target='_blank'
                                                rel="noreferrer"
                                            > {SpliUrl(document?.verso)} </a>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className='frame11DocCommerciaux'>
                                <StatutDocument
                                    statut={document?.statut}
                                    motifRejet={document?.motifRejet}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                /* align-items: flex-end; */
                                padding: '0px',
                                //gap: '8px',
                                flex: 'none',
                                order: '2',
                                alignSelf: 'stretch',
                                flexGrow: '0',
                            }}
                        >
                            <div className='frame8Kbis'>
                                <div className='frame9Kbis'>
                                    <p className='frame10Kbis'>
                                        {i18n.t('N°Document')}: {document?.noDoc}
                                    </p>
                                    <p className='frame10Kbis'>

                                        {i18n.t('Date de téléchargement')}: {formatDateJJMMYYYY(document?.createdAt)} {i18n.t('à')} {getTimeFromIsoFormatDate(document?.createdAt)}
                                    </p>

                                </div>
                                <div className='frame14Kbis'>

                                    <p className='frame10Kbis'>
                                        {i18n.t('Date de validité')}: {formatDateJJMMYYYY(document?.dateValidite)}
                                    </p>

                                </div>
                            </div>
                            {/*<div className="frame16Kbis">
                                <p className='frame10DocCommerciaux'>Téléchargé le {formatDateJJMMYYYY(document?.createdAt)}</p>
                            </div>*/}
                            {(document?.statut == 'encours' || document?.statut == 'rejete') && (
                                <div className="frame15Kbis">
                                    <div className="frame16Kbis">
                                        <Button
                                            variant="text"
                                            startIcon={<DeleteForeverIcon />}
                                            //color="error"
                                            style={{...buttonStyles(),...{color:'#EC5B56'}}}
                                            onClick={() => {
                                                supprimerPieceIdentite(document?._id);
                                            }}
                                        >
                                            {i18n.t('Supprimer')}
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            ))}
        </form>
    );

}

export default CardIdOCR;